module.exports = __webpack_public_path__ + "static/media/gm.d2b4a063.svg";